import { API_ROUTES } from '@/constants/apiRoutes';
import { PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { HoslogPlans, StatusType } from './hoslog-plans.types';

export interface planParams {
  row?: number;
  fetch?: number;
  fromDateMs?: number;
  toDateMs?: number;
  createdDate?: number;
  search?: string;
  statusFilter?: 'A' | 'R' | 'P';
}

export const getPlans = (client: AxiosInstance) => async (params?: planParams) => {
  return (await client.get<PaginatedApiResponse<HoslogPlans[]>>(API_ROUTES.GET_PLAN_LIST, { params })).data;
};

export const getPlanById = (client: AxiosInstance) => async (planId: string) => {
  return (
    await client.get<{ message: string; data: HoslogPlans }>('/manage-plan', {
      params: { planId },
    })
  ).data;
};

export const hoslogPostQueries = {
  all: () => ['hoslog-plans'],
  list: (type: StatusType, params?: planParams) =>
    queryFactoryOptions<PaginatedApiResponse<HoslogPlans[]>>({
      queryKey: [...hoslogPostQueries.all(), 'list', type, params],
      queryFn: (client) => () => getPlans(client)(params),
    }),
  details: (planId: string) =>
    queryFactoryOptions<{ message: string; data: HoslogPlans }>({
      queryKey: [...hoslogPostQueries.all(), 'details', planId],
      queryFn: (client) => () => getPlanById(client)(planId),
    }),
};
